import { Component, OnInit, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { AccountDefiningModel, DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { Router, ActivatedRoute } from '@angular/router';
import { G_TagsViewModel } from 'src/app/viewmodels/g-settings/G_TagsViewModel';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import Swal from 'sweetalert2';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { SaleDetailViewModel } from 'src/app/viewmodels/g-sale/SaleDetailViewModel';
import { GPackageItemViewModel } from 'src/app/viewmodels/g-packages/GPackageItemViewModel';
import { GPackagesViewModel } from 'src/app/viewmodels/g-packages/GPackagesViewModel';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { GPackagesModel, SaleDetailModel, SaveSaleMasterRequest, TagsModel } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { GPackageItemModel, SaveGVehicleRequest, SaveItemRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
import { AppConsts } from 'src/app/common/app-consts';

@Component({
  selector: 'app-edit-direct-sale',
  templateUrl: './edit-direct-sale.component.html',
  styleUrls: ['./edit-direct-sale.component.scss']
})
export class EditDirectSaleComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  modalRefLv3: BsModalRef;
  modalRef: BsModalRef;
  public vmListItems: any = [];
  @Input() public modal_title: any;
  @Input() public vmP: AccountDefiningModel;
  @Input() public vmp: GPackagesModel;
  public vm: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public vmDetail: number = 15;
  private submitted = false;
  public component_Title = 'Direct Sale';
  public customerDetail: any = [];
  public selectedcustomerDetail: any = [];
  public ccustomerDetail = 'customerDetail';
  public address: any;
  public files: File[] = [];
  public vehicleDetail: any = [];
  public selectedTagsList: any = [];
  public cvehicleDetail = 'vehicleDetail';
  public selectedvehicleDetail: any = [];
  public itemVm: SaveGVehicleRequest = new SaveGVehicleRequest();;
  bsmRef: any;
  @Output() onSubmitted = new EventEmitter<any>();
  public tags: any = [];
  public selectedTagList: any = [];
  public spareParts: any = [];
  public selectedSpareParts: any = [];
  public selectedemail: any = [];
  public itemTypes = [];
  public ssItemVm = new SaveItemRequest();
  public SelectedItemServices: any = [];
  public citems: any = 'items';
  public selectedDate: any;
  public DisableSave: boolean = false;
  public EnableNext: boolean = false;
  public isPreview: boolean = false;
  public thumbnail: any;
  public ComName: any;
  public Address: any;
  public contect: any;
  public services: any = [];
  public customerAccount: ItemViewModel1;
  public brandsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public modelsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true,
  };
  public PackageSelectionDropdown: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    limitSelection: 1
  };
  public defaultDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'registrationNumber',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  public CustomerDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'accTitle',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  public calingUrl: string;
  public urlId: string;
  public selectedServices: any = [];
  public maxDate = new Date();
  public client: any;
  public user: any;
  public tagsJoin: string = "";

  public userAssignedWareHouses: Array<any> = [];
  public totalExpense: number = 0;
  public allowedExpense: number = 0;
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    public _router: Router,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  name = "cpEmail";
  id = "id";
  checked = true;
  isdisabled = false;
  label = 'Toggle On/Off';
  labelledby = 'Some Other Text';


  onSelect(e) {

    this.files.push(...e.addedFiles);

    this.vm.file = this.files;
  }
  onChange(e) {
    debugger
    if (this.selectedvehicleDetail.length != 0) {
      let item = this.itemVm.customerEmail;
      if (e == true) {
        let i = new SaveSaleMasterRequest();
        this.vm.customerAccEmail = new ItemViewModel1(item.id, item.name);
        this.vm.isEmailRequired = true;
      } else {
        this.vm.customerAccEmail = null;
        this.vm.isEmailRequired = false;
      }
    } else {
      let item = this.selectedemail;
      if (e == true) {
        let i = new SaveSaleMasterRequest();
        this.vm.isEmailRequired = true;
        this.vm.customerAccEmail = new ItemViewModel1(
          item.id,
          item.cpEmail
        );
      } else {
        this.vm.customerAccEmail = null;
        this.vm.isEmailRequired = false;
      }
    }
  }

  onQrCodeChange(e) {
    debugger;
    if (e.target.checked == true) {
      this.vm.isQRGenerate = e.target.checked;
    }
    else {
      this.vm.isQRGenerate = false;
    }
  }
  onRemove(e) {
    console.log(e);
    this.files.splice(this.files.indexOf(e), 1);
  }


  ngOnInit() {
    debugger;
    this.spinner.show();
    this.client = this._localStorageService.get("com");
    this.user = this._localStorageService.get("ussr");
    this.vmDetail = parseInt(this.client.Vat);
    let selectedSaprePartsList: any = [];
    let selectedServicesList: any = [];
    let selectedTagLists: any = [];
    let selectedVehicle: any = [];
    let selectedCustomer: any = [];
    this.calingUrl = this._router.url;
    this.route.queryParams.subscribe(params => {
      this.urlId = params['id'];


    });

    this.itemVm.customer = new ItemViewModel1();

    debugger
    this._uow.gSaleService.GetGSaleByIdAsync(this.urlId).subscribe((res: any) => {
      debugger
      this.vm = res;
      this.getimage();
      this.getRegNo();
      this.getRequisitions();
      this.getTags();
      this.getCustomers();
      this.getServices();

      this.getUserAssingnedWareHouses().then((result: any) => {
        this.getSpareParts(res.model.id, res.gWareHouse.id);
      });

      debugger
      this.vm.transactionDate = new Date(res.transactionDate);
      this.itemVm.odometer = res.odometer;
      this.itemVm.driverName = res.driverName;
      this.itemVm.driverPhone = res.driverPhone;
      this.itemVm.customer = res.gCustomer;
      //this.vm.Fk_G_WareHouse_Id = new ItemViewModel(res.Fk_G_WareHouse_Id.Id, res.Fk_G_WareHouse_Id.Name);
      console.log(res);
      // this._jq.showSpinner();
      debugger
      let veh = new SaveGVehicleRequest();
      veh.id = this.vm.gVehicle.id;
      veh.registrationNumber = this.vm.gVehicle.name;
      selectedVehicle.push(veh);
      this.selectedvehicleDetail = selectedVehicle;
      this.itemVm.registrationNumber = veh.registrationNumber;
      this.itemVm.model = new ItemViewModel1(res.model.id, res.model.name);
      this.itemVm.brand = new ItemViewModel1(res.brand.id, res.brand.name);
      this.itemVm.id = res.gVehicle.id
      this.itemVm.name = res.gVehicle.name;
      this.itemVm.customerEmail = res.customerAccEmail;
      this.customerAccount = new ItemViewModel1(
        res.customerAcc.id,
        res.customerAcc.name
      );
      if (this.vm.vatValue != undefined) {
        this.vmDetail = this.vm.vatValue;
      }
      let cust = new AccountDefiningModel();
      cust.id = this.vm.gCustomer.id;
      cust.accTitle = this.vm.gCustomer.name;
      selectedCustomer.push(cust);
      this.selectedcustomerDetail = selectedCustomer;

      this.vm.spareParts.forEach(x => {

        let ab = new GPackageItemModel();
        ab.quantity = x.quantity;
        ab.ssItemDefining = new ItemViewModel1(x.item.id, x.item.name);
        ab.discountPercentage = x.discount;
        ab.salePrice = 0;
        ab.salePrice = x.salePrice;
        ab.amount = 0;
        ab.amount = x.totalAmount;
        ab.discountAmount = 0;
        ab.discountAmount = x.discountAmount;
        ab.rate = x.rate;
        this.vmp.spareParts.push(ab);
        let partssSelected = new SaveItemRequest();
        partssSelected.id = x.item.id;
        partssSelected.name = x.item.name;
        selectedSaprePartsList.push(partssSelected);
        //this.InventoryCheck(x.FK_G_Item_Id.Id);
        this.discountChange(ab, 0);
      });
      this.selectedSpareParts = selectedSaprePartsList;

      this.vm.saleDetails.forEach(x => {
        x.vatValue = this.vmDetail;
      });

      this.vm.services.forEach(x => {

        let ab = new GPackageItemModel();
        ab.quantity = x.quantity;
        ab.ssItemDefining = new ItemViewModel1(x.item.id, x.item.name);
        ab.discountPercentage = x.discount;
        ab.salePrice = 0;
        ab.salePrice = x.salePrice;
        ab.amount = 0;
        ab.amount = x.totalAmount;
        ab.discountAmount = 0;
        ab.discountAmount = x.discountAmount;
        ab.rate = x.rate;
        this.vmp.services.push(ab);
        let partssSelected = new SaveItemRequest();
        partssSelected.id = x.item.id;
        partssSelected.name = x.item.name;
        selectedServicesList.push(partssSelected);
        //this.InventoryCheck(x.FK_G_Item_Id.Id);
        this.discountChange(ab, 0);
      });
      this.SelectedItemServices = selectedServicesList;
      this.vm.salesTagsList.forEach(x => {
        let selectedTag = new TagsModel();
        selectedTag.id = x.id;
        selectedTag.fkTagId = x.fkTagId;
        selectedTag.name = x.name;
        selectedTagLists.push(selectedTag);
      });
      this.selectedTagsList = selectedTagLists;
    });

    debugger
    if (this.itemVm.tagList !== undefined && this.itemVm.tagList.length > 0) {
      this.itemVm.tagList.forEach(x => {
        this.selectedTagList.push(new ItemViewModel1(x.id, x.name));
      });
    }
    if (this.itemVm == undefined) {
      this.itemVm = new SaveGVehicleRequest();
      this.vehicleDetail = [];
      this.selectedvehicleDetail = [];
    } else {

    }
    if (this.vmP == undefined) {
      this.vmP = new AccountDefiningModel();
      this.customerDetail = [];
      this.selectedcustomerDetail = [];
    } else {

    }
    if (this.modal_title == undefined) {
      this.modal_title = 'Sale';
    }
    if (this.vmp == undefined) {
      this.vmp = new GPackagesModel();
      this.vm = new SaveSaleMasterRequest();
      this.vmp.spareParts = [];
      this.vmp.services = [];

      this.vm.statusType = new ItemViewModel1(8, "SaleInvoice");
    } else {
      if (this.vm.salesTagsList !== undefined && this.vm.salesTagsList.length > 0) {
        this.vm.salesTagsList.forEach(x => {
          this.selectedTagsList.push(new ItemViewModel1(x.id, x.name));
        });
      }

      if (this.vmp.spareParts !== undefined && this.vmp.spareParts.length > 0) {
        this.vmp.spareParts.forEach(x => {
          this.selectedSpareParts.push(new ItemViewModel1(x.ssItemDefining.id, x.ssItemDefining.name));
        });
      }
      if (this.vmp.services !== undefined && this.vmp.services.length > 0) {
        this.vmp.services.forEach(x => {
          this.selectedServices.push(new ItemViewModel1(x.ssItemDefining.id, x.ssItemDefining.name));
        });
      }
    }
    this.spinner.hide();
  }

  getUserAssingnedWareHouses() {
    return new Promise((resolve, reject) => {
      this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe((res: any) => {
        debugger
        console.log("warehouses", res);
        this.userAssignedWareHouses = res.result;

        if (this.vm.gWareHouse && this.userAssignedWareHouses.length > 0) {
          this.vm.gWareHouse = this.userAssignedWareHouses.find(
            (w: any) => w.wareHouse.id === this.vm.gWareHouse.id
          ).wareHouse || null;

          this.getSpareParts(this.itemVm.model.id, this.vm.gWareHouse.id);
        }
        resolve(res);
      });
    });
  }

  getRegNo() {
    this.spinner.show();
    this._uow.gSettingService.GetGVehiclesByUserAsync().subscribe((res: any) => {
      this.vehicleDetail = res.result;
      this.spinner.hide();
    }, (error) => {
      this._uow.logger.log(error);
      this.spinner.hide();
    });
  }



  getimage() {

    this._uow.gSettingService.GetHeaderFootersDropDownAsync().subscribe((baseImage: any) => {
      console.log(baseImage);
      debugger;
      if (baseImage != undefined && baseImage !== null) {
        if (baseImage.attachment != undefined && baseImage.attachment !== null) {

          this.thumbnail = `https://fleetdesks.s3.eu-central-1.amazonaws.com/${baseImage.attachment}`;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        } else {
          this.thumbnail = baseImage.compName;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        }
      }
    }, (err) => {
      console.log(err);
    })
  }


  getCustomers() {
    debugger;
    let Customer = AppConsts.CUSTOMER;
    if (this.vm.paymentType === 2) {
      Customer = "Cash";
    }
    if (this.vm.paymentType === 3) {
      Customer = "Office";
    }
    this._uow.gSettingService.GetGCustomersDropDownAsync(Customer).subscribe(
      (res: any) => {
        debugger;
        this.customerDetail = res.result;
        if (this.customerDetail.length > 0) {
          // // debugger;
          this.customerDetail.forEach(x => {
            id: x.id;
            accTitle: x.accCode + '-' + x.accTitle
          });
        }
        this.vmP = res.result;
        this.vmP.accCode = res.accCode;
        this.vmP.accTitle = res.accCode + "" + res.accTitle;

        // this.itemVm.RegistraionNumber = res;
        console.log(res);
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this._jq.showSpinner();
      }
    );
  }

  getCustomerName() {
    this._uow.gSettingService.GetGCustomersDropDownAsync(AppConsts.CUSTOMER).subscribe(
      (res: any) => {

        this.customerDetail = res.result;

        // this.itemVm.RegistraionNumber = res;
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this._jq.showSpinner();
      }
    );
  }

  getRequisitions() {
    console.log(this.selectedvehicleDetail);
    this._uow.gSettingService.GetGVehiclesAsync().subscribe(
      (res: any) => {
        // console.log(res);
        this.vehicleDetail = res.result;
      },
      (error) => {
        this._uow.logger.log(error);
        this.vehicleDetail = [];
      }
    );
  }

  getTags() {
    debugger
    this.tags = [];
    this._uow.gSettingService.GetTagsAsync().subscribe(

      (res: any) => {
        debugger
        this.tags = res.result;
      },
      (err) => console.log(err)
    );
  }
  getServices() {
    // 'Services'
    this._jq.showSpinner(true);
    this._uow.gSettingService.GetItemsDropDownByTypeAsync("Services").subscribe(
      (res: any) => {
        this.services = res.result;
        console.log(res);
        this._jq.showSpinner();
        // this._uow.logger.log(`services ${res}`);
      },
      (err) => {
        this._uow.logger.log(err);
        this.services = [];
        this._jq.showSpinner();
      }
    );
  }

  getSpareParts(modelId, wareId?) {
    debugger;
    let selectedSpare: any = [];
    this._uow.gSettingService
      .GetItemsDropDownByModelAndTypeIdAsync(modelId, wareId)
      .subscribe(
        (res: any) => {
          debugger
          this.spareParts = res.result;
          this.InventoryCheckAll();
          console.log("spare parts", res);
          if (this.selectedSpareParts.length > 0) {
            console.log(this.selectedSpareParts);
            this.selectedSpareParts.forEach((x) => {
              let selected = this.vmp.spareParts.find((z) => z.ssItemDefining.id === x.id);
              console.log("selcetd part", selected);
              let md = new ItemViewModel1();
              md.id = selected.ssItemDefining.id,
                md.name = selected.ssItemDefining.name
              selectedSpare.push(md);
              this.selectedSpareParts = selectedSpare;
            });
          }
        },
        (err) => {
          this._uow.logger.log(err);
          this.spareParts = [];
        }
      );
  }

  InventoryCheckAll() {

    if (this.vmp.spareParts != undefined && this.vmp.spareParts.length > 0) {
      this.vmp.spareParts.forEach((x) => {
        let SparepartsEvent = this.spareParts.find(
          (y) => y.id === x.ssItemDefining.id
        );
        if (SparepartsEvent != undefined && SparepartsEvent != null) {
          if (x.quantity > SparepartsEvent.currentStock) {
            x.isInventry = false;
            //this.DisableSave = true;
          } else {
            x.isInventry = true;
            //this.DisableSave = false;
          }
        }
      });
      let DisableSave = this.vmp.spareParts.find(x => x.isInventry === false);
      if (DisableSave) {
        this.DisableSave = true;
      } else {
        this.DisableSave = false;
      }
    } else {
      this.DisableSave = false;
    }
    this.DisableSave = false;
  }


  onSelectvehicleDetail(e) {
    debugger
    this._uow.logger.log(e);
    console.log('details', e);
    let selectedCustomerList: any = [];
    let selectedWareHouseList: any = [];

    let item = this.vehicleDetail.find((x) => x.id === e.id);

    if (item !== undefined) {
      console.log(item);
      this.itemVm = item;
      this.itemVm.name = item.name;
      this.itemVm.registrationNumber = item.registrationNumber;
      this.itemVm.tagList = item.tagList;
      this.itemVm.customer.id = item.customer.id;
      this.itemVm.customer.name = item.customer.name;
      // this.vm.FK_WareHouse_Id = new ItemViewModel(item.FK_WareHouse_Id.Id,item.FK_WareHouse_Id.Name);
      this.customerAccount = new ItemViewModel1(
        item.customer.id,
        item.customer.name
      );
      this.itemVm.customerDiscount = item.customerDiscount;
      if (this.itemVm.customer.id != null) {
        let custList = new AccountDefiningModel();
        custList.id = this.itemVm.customer.id;
        custList.accTitle = this.itemVm.customer.name;
        // this.itemVm.Fk_G_Customer_Id.Id =item.Id;
        // this.itemVm.Fk_G_Customer_Id.Name =item.Acc_Titel;
        custList.discountValue = this.itemVm.customerDiscount;
        selectedCustomerList.push(custList);
        console.log(this.itemVm);
        this.selectedcustomerDetail = selectedCustomerList;
      } else {
        this.selectedcustomerDetail = null;
        let cd = document.getElementById("customerdetail");
        cd.classList.add("required");
      }
    }
  }

  onDeSelectvehicleDetail(e) {
    if (this.selectedvehicleDetail.length == 0) {
      this.itemVm = new SaveGVehicleRequest();
      this.itemVm.registrationNumber = this.itemVm.registrationNumber;
      this.getRegNo();
      this.vmP = new AccountDefiningModel();
      this.vmP.id = this.vmP.id;
      this.vmP.accTitle = this.vmP.accTitle;
      this.selectedcustomerDetail = [];
      this.getCustomerName();
    }
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.itemVm = new SaveGVehicleRequest();
    }
  }

  onSelectcustomerDetail(e) {
    let selectedCustomerL: any = [];
    this._uow.logger.log(e);
    if (this.vm.paymentType === 1) {
      let selectedVehicle: any = [];
      let item = this.customerDetail.find((x) => x.id === e.id);
      let item2 = this.vehicleDetail.find((y) => y.id === e.id);
      if (item !== undefined) {
        this.vmP = item;
        this.vmP.id = item.id;
        this.vmP.accTitle = item.accTitle;
        this.vmP.cpEmail = item.cpEmail;
        this.selectedemail.push(item);
        let VehList = new SaveSaleMasterRequest();
        VehList.gCustomer = new ItemViewModel1(0, "");
        VehList.gCustomer.id = item.id;
        VehList.gCustomer.name = item.accTitle;
        this.itemVm.customer.id = item.id;
        this.itemVm.customer.name = item.accTitle;
        this.customerAccount = new ItemViewModel1(item.id, item.accTitle);
        this.vmP.id = VehList.gCustomer.id;
        this.vmP.accTitle = VehList.gCustomer.name;
        selectedCustomerL.push(VehList);
      }
      selectedCustomerL = selectedVehicle = this.selectedvehicleDetail;
      selectedCustomerL = this.selectedcustomerDetail;
      selectedVehicle = this.selectedvehicleDetail;
    }
    else if (this.vm.paymentType === 3) {
      let selectedVehicle: any = [];
      let item = this.customerDetail.find((x) => x.id === e.id);
      let item2 = this.vehicleDetail.find((y) => y.id === e.id);
      if (item !== undefined) {
        this.vmP = item;
        this.vmP.id = item.id;
        this.vmP.accTitle = item.accTitle;
        this.vmP.cpEmail = item.cpEmail;
        this.selectedemail.push(item);
        let VehList = new SaveSaleMasterRequest();
        VehList.gCustomer = new ItemViewModel1(0, "");
        VehList.gCustomer.id = item.id;
        VehList.gCustomer.name = item.accTitle;
        this.itemVm.customer.id = item.id;
        this.itemVm.customer.name = item.accTitle;
        this.customerAccount = new ItemViewModel1(item.id, item.accTitle);
        this.vmP.id = VehList.gCustomer.id;
        this.vmP.accTitle = VehList.gCustomer.name;
        selectedCustomerL.push(VehList);
      }
      selectedCustomerL = selectedVehicle = this.selectedvehicleDetail;
      selectedCustomerL = this.selectedcustomerDetail;
      selectedVehicle = this.selectedvehicleDetail;
    }
    else {
      let item = this.customerDetail.find((x) => x.id === e.id);
      let item2 = this.vehicleDetail.find((y) => y.id === e.id);
      let VehList = new SaveSaleMasterRequest();
      VehList.gCustomer = new ItemViewModel1(0, "");
      VehList.gCustomer.id = e.id;
      VehList.gCustomer.name = e.accTitle;
      this.vmP.id = VehList.gCustomer.id;
      this.vmP.accTitle = VehList.gCustomer.name;
      this.vm.gCustomer.id = e.id;
      this.vm.gCustomer.name = item.accTitle;
      this.itemVm.customer.id = item.id;
      this.itemVm.customer.name = e.accTitle;
      this.customerAccount = new ItemViewModel1(e.id, e.accTitle);
      selectedCustomerL.push(VehList);
    }
  }

  onDeSelectcustomerDetail(e) {
    if (this.selectedcustomerDetail.length == 0) {
      this.vmP = new AccountDefiningModel();
      this.vmP.accTitle = this.vmP.accTitle;
      this.getRegNo();
    }
  }

  vatChanged() {

    if (this.vmDetail > -1) {
      if (this.vm.saleDetails !== undefined && this.vm.saleDetails.length > 0) {
        this.vm.saleDetails.forEach((x) => {
          x.vatValue = this.vmDetail;
          x.vatAmount = (x.totalAmount / 100) * this.vmDetail;
          // x.VatAmount =  (x.VatAmount.toFixed(2);
        });
      }
      if (this.vmp.spareParts !== undefined && this.vmp.spareParts.length > 0) {
        this.vmp.spareParts.forEach((x) => {
          x.vatAmount = (x.amount / 100) * this.vmDetail;
          x.totalAmount = x.amount + x.vatAmount;

        });
      }

      if (this.vmp.services !== undefined && this.vmp.services.length > 0) {
        this.vmp.services.forEach((x) => {
          x.vatAmount = (x.amount / 100) * this.vmDetail;
          x.totalAmount = x.amount + x.vatAmount;
          // x.VatAmount =  x.VatAmount.toFixed(2);
          // x.VatAmount.toFixed(2);
        });
      }
      this.calculateTotals();
    }
  }

  public TotalPayable = 0;
  public TotalVat: number;
  public TotalPayableAfterVat = 0;
  calculateTotals() {
    this.TotalPayableAfterVat = 0;
    this.TotalVat = 0;
    this.TotalPayable = 0;
    this.vmp.discountAmount = 0;
    this.vmp.partsAmount = 0;
    if (this.vm.saleDetails !== undefined && this.vm.saleDetails.length > 0) {
      this.vmp.spareParts.forEach((x) => {
        this.vmp.partsAmount += x.amount;
        this.TotalVat += x.vatAmount;
        if (x.discountAmmount > 0) {
          this.vmp.discountAmount += x.discountAmmount * x.quantity;
        }
      });
      this.vmp.serviceAmount = 0;
      this.vmp.services.forEach((x) => {
        x.vatAmount = x.vatAmount;
        this.vmp.serviceAmount += x.amount;
        this.TotalVat += x.vatAmount;
        if (x.discountAmmount > 0) {
          this.vmp.discountAmount += x.discountAmmount * x.quantity;
        }
      });
    }
    this.vmp.packageAmount =
      this.vmp.partsAmount + this.TotalVat + this.vmp.serviceAmount;
    // if(this.vm.PaymentType === 3){
    this.totalExpense = this.vmp.packageAmount;
    this.allowedExpense = this.vmp.packageAmount;
    this.vm.allowedExpense = this.allowedExpense;
    this.vm.totalExpense = this.totalExpense;
    // }

  }

  getSupCashList() {
    this.vmP = new AccountDefiningModel();
    this.vmP.accTitle = this.vmP.accTitle;
    this.selectedcustomerDetail = [];
    this.getCustomers();
  }
  onSelectWareHouse() {
    debugger
    this.selectedSpareParts = null;
    this.spareParts = [];
    this.vmp.spareParts = [];
    this.getSpareParts(this.itemVm.model.id, this.vm.gWareHouse.id);
  }

  // spare parts
  onSelectSparePart(e) {
    if (this.vm.saleDetails == undefined || this.vm.saleDetails.length == 0) {
      this.vm.saleDetails = [];
    }
    this._uow.logger.log(e);
    let item = this.spareParts.find((x) => x.id === e.id);
    if (item !== undefined) {
      let i = new SaleDetailModel();
      i.id = 0;
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      i.itemCode = item.code;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.totalAmount = item.salePrice;
      i.rate = item.salePrice;
      i.discountedRate = item.salePrice;
      i.itemType = item.itemType;
      i.vatAmount = 0;
      i.vatValue = 0;
      i.discount = 0;
      i.discountAmount = 0;
      this.vm.saleDetails.push(i);
      let a = new GPackageItemModel();
      a.id = 0;
      a.quantity = 1;
      a.ssItemDefining = new ItemViewModel1(item.id, item.name);
      a.discountPercentage = 0;
      a.salePrice = item.salePrice;
      a.amount = 0;
      a.amount = item.salePrice;
      a.discountAmount = item.salePrice;
      if (this.itemVm.customerDiscount > 0) {
        a.discountPercentage = this.itemVm.customerDiscount;
      }
      this.vmp.spareParts.push(a);
      this.discountChange(this.vmp.spareParts[this.vmp.spareParts.indexOf(a)]);
      //this.selectedSpareParts.push(a);
    }
    this.vatChanged();
    this.calculateTotals();
    this.InventoryCheck(e.Id);
  }

  onDeSelectSparePart(e) {
    debugger;
    let i = this.vmp.spareParts.find(
      (x) => x.ssItemDefining.id === e.id
    );
    if (i !== undefined) {
      this.vmp.spareParts.splice(this.vmp.spareParts.indexOf(i), 1);
    }
    let d = this.vm.saleDetails.find((x) => x.item.id === e.id);
    if (d !== undefined) {
      this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
    }
    // let a = this.vm.SpareParts.find(x=> x.FK_G_Item_Id.Id === e.Id);
    //   if(a !== undefined){
    //     this.vm.SpareParts.splice(this.vm.SpareParts.indexOf(a),1);
    //   }

    this.calculateTotals();
    this.InventoryCheckAll();
  }

  discountChange(e, i?) {
    let discountAMmount = (e.discountPercentage * e.salePrice) / 100;
    e.discountAmmount = discountAMmount;
    e.discountAmount = e.salePrice - e.discountAmmount;
    e.amount = e.discountAmount * e.quantity;
    let saledtl = this.vm.saleDetails.find(
      (x) => x.item.id === e.ssItemDefining.id
    );
    if (saledtl != undefined) {
      saledtl.rate = e.salePrice;
      saledtl.salePrice = e.salePrice;
      saledtl.discountAmount = e.discountAmmount;
      saledtl.discount = e.discountPercentage;
      saledtl.discountedRate = e.discountAmount;
      saledtl.totalAmount = e.amount;
    }
    // if(this.vmP.DiscountAmount > 0){
    //
    //   this.calculateTotals();
    // }
    // if(this.vmP.DiscountAmount <= 0){
    //   let discountAMmount = ((e.DescountPercentage / 100) * e.Amount);
    //   e.Amount = (e.Amount - discountAMmount);
    //   this.calculateTotals();
    // }
    this.vatChanged();
    //this.calculateTotals();
  }
  InventoryCheck(e) {

    let SparepartsEvent = this.spareParts.find((y) => y.id === e);
    if (SparepartsEvent != undefined && SparepartsEvent != null) {
      let AlreadySelectedParts = this.vmp.spareParts.find(
        (y) => y.ssItemDefining.id === e
      );
      if (AlreadySelectedParts != undefined && AlreadySelectedParts != null) {
        let AlreadyPartsIndex = this.vmp.spareParts.indexOf(
          AlreadySelectedParts
        );
        if (AlreadySelectedParts.quantity > SparepartsEvent.currentStock) {
          if (AlreadyPartsIndex != undefined) {
            this.vmp.spareParts[AlreadyPartsIndex].isInventry = false;
          }
          //this.DisableSave = true;
        } else {
          if (AlreadyPartsIndex != undefined) {
            this.vmp.spareParts[AlreadyPartsIndex].isInventry = true;
          }
          AlreadySelectedParts.isInventry = true;
          //this.DisableSave = false;
        }
      }
    }
    this.InventoryCheckAll();
  }

  openModalLg(template: TemplateRef<any>, itemtype?) {
    this.ssItemVm = new SaveItemRequest();
    if (itemtype == 1) {
      let i = this.itemTypes.find((x) => x.name == "Spare-Parts");
      console.log(i);
      this.ssItemVm.itemType = new ItemViewModel1(i.id, i.name);
    }
    if (itemtype == 2) {
      let i = this.itemTypes.find((x) => x.name == "Services");
      this.ssItemVm.itemType = new ItemViewModel1(i.id, i.name);
    }
    this.openModal(template);
    this.modalRef.setClass("modal-lg");
  }

  //service
  onSelectService(e) {
    debugger;
    if (this.vm.saleDetails == undefined || this.vm.saleDetails.length == 0) {
      this.vm.saleDetails = [];
    }
    if (
      this.SelectedItemServices == undefined ||
      this.SelectedItemServices.length == 0
    ) {
      this.SelectedItemServices = [];
    }
    this._uow.logger.log(e);
    let item = this.services.find((x) => x.id === e.id);
    if (item !== undefined) {
      let i = new SaleDetailModel();
      i.id = 0;
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      i.itemCode = item.code;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.totalAmount = item.salePrice;
      i.rate = item.salePrice;
      i.discountedRate = item.salePrice;
      i.itemType = item.itemType;
      i.vatAmount = 0;
      i.vatValue = 0;
      i.discount = 0;
      i.discountAmount = 0;
      this.vm.saleDetails.push(i);
      let a = new GPackageItemModel();
      a.id = 0;
      a.quantity = 1;
      a.ssItemDefining = new ItemViewModel1(item.id, item.name);
      a.discountPercentage = 0;
      a.salePrice = item.salePrice;
      a.amount = 0;
      a.amount = item.salePrice;
      a.discountAmount = item.salePrice;
      if (this.itemVm.customerDiscount > 0) {
        a.discountPercentage = this.itemVm.customerDiscount;
      }
      this.vmp.services.push(a);
      this.discountChange(this.vmp.services[this.vmp.services.indexOf(a)]);
      this.SelectedItemServices.push(item);
    }
    this.vatChanged();
    this.calculateTotals();
  }

  onDeSelectService(e) {
    let i = this.vmp.services.find((x) => x.ssItemDefining.id === e.id);
    if (i !== undefined) {
      this.vmp.services.splice(this.vmp.services.indexOf(i), 1);
    }
    let d = this.vm.saleDetails.find((x) => x.item.id === e.id);
    if (d !== undefined) {
      this.vm.saleDetails.splice(this.vm.saleDetails.indexOf(d), 1);
    }
    this.calculateTotals();
  }

  public amountCheck: boolean = false;
  onEnterAmount() {
    if (this.vm.allowedExpense > this.vm.totalExpense) {
      this.amountCheck = true;
      return;
    }
    if (this.vm.allowedExpense <= this.vm.totalExpense) {
      this.amountCheck = false;
    }
  }
  quantityChange(e, i?) {
    //e.DiscountAmount = 0;
    e.amount = e.quantity * e.discountAmount;
    let saledetail = this.vm.saleDetails.find(
      (x) => x.item.id === e.ssItemDefining.id
    );
    if (saledetail != undefined) {
      saledetail.quantity = e.quantity;
      saledetail.totalAmount = e.amount;
    }
    //  if (e.DescountPercentage > 0) {
    //    e.Amount = (e.Amount - ((e.DescountPercentage / 100) * e.Amount));
    //  }
    //this.calculateTotals();
    this.vatChanged();
    this.InventoryCheckAll();
  }

  vatAmountChanged(i) {
    this.calculateTotals();
  }

  onSelectTags(e) {
    if (
      this.vm.salesTagsList == undefined ||
      this.vm.salesTagsList.length == 0
    ) {
      this.vm.salesTagsList = [];
    }
    this._uow.logger.log(e);
    let item = this.tags.find((x) => x.id === e.id);
    if (item !== undefined) {
      let i = new TagsModel();
      i.id = item.id;
      i.name = item.name;
      i.fkTagId = item.id;
      this.vm.salesTagsList.push(i);
      // let a = new G_SaleMasterViewModel();
      // a.Id = item.Id;
      // a.Name = item.Name;
      // this.vm.SalesTags.push(i);
    }
  }

  onDeSelectTags(e) {
    let i = this.vm.salesTagsList.find((x) => x.fkTagId === e.id);
    if (i !== undefined) {
      this.vm.salesTagsList.splice(this.vm.salesTagsList.indexOf(i), 1);
    }
  }

  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template);
      this.modalRef.setClass("modal-lg");
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
    if (lvl == 3) {
      this.modalRefLv3 = this._modalService.show(template);
    }
    // if (lvl == 2) {
    //   this.modalRefLv2 = this._modalService.show(template);
    // }
  }
  amountChange(e, i?) {
    e.discountPercentage = (e.discountAmmount * 100) / e.salePrice;
    this.discountChange(e, i);
    this.vatChanged();
    //this.calculateTotals();
    // if(this.vmP.DiscountAmount > 0){
    //
    //   this.calculateTotals();
    // }
    // if(this.vmP.DiscountAmount < 0){
    //   let discountAMmount = (e.Amount-e.DescountAmmount);
    //   e.Amount = (discountAMmount);

    // }
  }


  openPreview(content) {
    debugger
    this.tagsJoin = this.selectedTagsList.map(tag => tag.Name).join(", ");
    this.modalRef = this._uow.modalServiceEx.show(content);
    this.modalRef.setClass("modal-lg");
    this.isPreview = true;
  }

  saveOrUpdate() {
    debugger;
    // this._jq.showSpinner(true);
    this._uow.gSettingService
      .SaveGVehicleAsync(this.itemVm)
      .toPromise()
      .then((res: any) => {
        console.log(res);
        this.submitted = true;
        this.onSubmitted.emit(this.submitted);
      })
      .catch((error) => {
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(false);
        return;
        this._jq.showSpinner();
      });

    this._jq.showSpinner(true);
    let obj = this.itemVm;
    //  binding vm object by itemvm
    this.vm.driverName = this.itemVm.driverName;
    this.vm.driverPhone = this.itemVm.driverPhone;
    //this.vm.refId = "test";
    this.vm.vatValue = this.vmDetail;
    //this.vm.Inv = 1234;
    this.vm.validity = 1;
    this.vm.model = new ItemViewModel1();
    this.vm.model.id = this.itemVm.model.id;
    this.vm.model.name = this.itemVm.model.name;
    this.vm.brand = new ItemViewModel1();
    this.vm.brand.id = this.itemVm.brand.id;
    this.vm.brand.name = this.itemVm.brand.name;
    this.vm.gVehicle = new ItemViewModel1();
    this.vm.gVehicle.id = this.itemVm.id;
    this.vm.gVehicle.name = this.itemVm.name;
    this.vm.registrationNumber = this.itemVm.registrationNumber;
    this.vm.gCustomer = new ItemViewModel1();
    this.vm.gCustomer.name = this.itemVm.customer.name;
    this.vm.gCustomer.id = this.itemVm.customer.id;
    this.vm.customerAcc = new ItemViewModel1();
    this.vm.customerAcc.id = this.customerAccount.id;
    this.vm.customerAcc.name = this.customerAccount.name;
    if (this.vm.paymentType == 1) {
      this.onChange(true);
    }
    this.vm.creditAcc = new ItemViewModel1();
    this.vm.creditAcc.id = 0;
    this.vm.creditAcc.name = "";
    this.vm.statusType = new ItemViewModel1(8, "SaleInvoice");
    // this.vm.Fk_G_Tags_Id = new ItemViewModel();
    // this.vm.Fk_G_Tags_Id .Id = 0;
    // this.vm.Fk_G_Tags_Id.Name = "";
    this.vm.spsType = new ItemViewModel1();
    this.vm.spsType.id = 0;
    this.vm.spsType.name = "";
    //this.vm.Remarks = "";
    // this.vm.PaymentType = 1;
    this.vm.status = "";
    this.vm.invAmount = this.vmp.packageAmount;
    this.vm.paidAmount = this.vm.invAmount;
    this.vm.partsAmount = this.vmp.partsAmount;
    this.vm.serviceAmount = this.vmp.serviceAmount;
    this.vm.isPaymentDone = false;
    this.vm.isCredit = false;
    this.vm.isCounterSale = true;
    this.vm.odometer = parseInt(this.itemVm.odometer);
    this.vm.attachment = "";
    // let a = new GPackagesViewModel();
    // this.vm.PackageDetail = [];
    // //a.Fk_PackageType_Id.Id = this.vmP.Id;
    // //a.Fk_PackageType_Id.Name = this.vmP.Name;
    // a.Id = this.vmP.Id;
    // a.Name = this.vmP.Name;
    // a.PartsAmount = this.vmP.PartsAmount;
    // a.ServiceAmount = this.vmP.ServiceAmount;
    // a.PackageAmount = this.vmP.PackageAmount;
    // a.TotalAmount = this.vmP.TotalAmount;
    // a.Discount = this.vmP.Discount;
    // a.DiscountAmount = this.vmP.DiscountAmount
    // this.vm.PackageDetail.push(this.packageTypes);
    //  let i = new G_ComplainsSuggestionsViewModel();
    //  this.vm.CustomerComplains = [];
    //  i.fk = this.vmC.FK_G_Complains_Id.Id;
    //  i.Name = this.vmC.Name;
    //i.FK_G_Complains_Id = this.vmC.FK_G_Complains_Id,
    //i.ComplainsType = this.vmC.ComplainsType;
    // this.vm.CustomerComplains.push(this.complaintsType);
    // this.vm.Findings =[];
    // this.complaintsType.Id = this.vmC.Id;
    // this.complaintsType.Name = this.vmC.Name;
    // this.vm.Findings.push(this.complaintsType);
    this.vm.attachmentList = "";
    this.spinner.show();
    this._uow.gSaleService
      .SaveGSaleAsync(this.vm)
      .toPromise()
      .then((res: any) => {
        debugger
        console.log(res);
        this.vm = res;
        this.submitted = true;
        this.onSubmitted.emit(this.submitted);
        //this.bsmRef.hide();
        this.vm = res;
        this.EnableNext = true;
        if (this.isPreview == true) {
          this.modalRef.hide();
        }

        this.spinner.hide();
        Swal.fire("Saved!", "Direct Sale Created!", "success");
        // this._jq.showSpinner();
        this._router.navigate(["/direct-sale-list"]);
      })
      .catch((error) => {
        Swal.fire("Error!", "Direct Sale Not Saved!", "error");
        this._uow.logger.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(false);
        // this._jq.showSpinner();
        this.spinner.hide();
      });
  }
  OpenCreateDirectInvoice(e) {
    this._router.navigate(["/direct-sale-invoice", { id: e }]);
  }

  public deleteId: string;
  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template, 1);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;
    }
  }

  // external components
  onItemSubmitted(e) {
    if (e == true) {
      this.getTags();
      this._jq.showSpinner(false);
    }
  }


  navigateClick() {
    this.isPreview = false;
    this.modalRef.hide();
  }



















































  // onChangeExpense(){

  // this.vm.AllowedExpense = this.vm.TotalExpense - this.vm.AllowedExpense;
  // }





























  //'Spare-Parts'






  // saveOrUpdate() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.Post(this.vm).subscribe((res: any) => {
  //     this.getList();
  //     this.modalRefLv1.hide();
  //   }, (err) => {
  //     this._jq.showSpinner();
  //   });
  // }









}
